<script setup>
import axios  from "axios";
axios.defaults.baseURL = 'https://qlipper.jp/';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
  <div class="settings-form">
    <div class="input-crowd">
    <div class="contents__title">
     <h2 class="contents__title-text">Googleカレンダーと連携</h2>

     <p class="contents__title-supplement">Googleの様々なサービスと連携するための設定を行います。Googleカレンダー との連携を行います</p>

    </div>
     <div class="input-change-status-box">

      <a href="#" class="icon-text__anchor -moderate" v-if="cal_status == true" v-on:click="del_cal_token()">
       <i class="icon -stop -emphasis"></i>
       <span class="icon-text__anchor-text">連携を解除する</span>
      </a>
      <a href="https://qlipper.jp/google_cal" class="icon-text__anchor" v-else>
       <i class="icon -start -emphasis"></i>
       <span class="icon-text__anchor-text">連携を開始する</span>
      </a>

     </div>
   </div>
    <div class="google_aling_message_box">
        <div class="google_aling_img_box">
            <img src="https://qlipper.jp/images/google_align.png">
            <div class="google_aling_attention_box"></div>
        </div>
        <div class="google_aling_explanation_box">
            <span class="google_explanation">
            <p>Googleのサービスとの連携を実行できます。</p>

            閲覧権限があるGoogle アカウントにログイン<br>
            <br />
            左の画面が表示されます。<br />
            <br />
            表示された<span class="google_attention">チェックボックスにすべてチェック</span>して認証を実行してください。 <br />
            </span>


        </div>
    </div>
</div>
</template>
<script>
export default {
  head: {
    title() {
      return {
        inner: '設定',
        separator: '|',
        complement: 'PR効果測定 Qlipper',
      }
    },
      link:
        [
          { rel: 'stylesheet', href: "https://qlipper.jp/css/common_vuetify.css" },
          { rel: 'stylesheet', href: "https://qlipper.jp/css/relcreate.css" },
          { rel: 'stylesheet', href: "https://qlipper.jp/css/vuetify_custom.css" },
          { rel: 'stylesheet', href: "https://qlipper.jp/css/service_align.css" },
          { rel: 'stylesheet', href: "https://cdn.jsdelivr.net/npm/@mdi/font@7.3.67/css/materialdesignicons.min.css" },
        ],
  },
	data : function(){
		return {
			cal_status : false,
		};
	},
	methods : {
		// テスト検索を行う処理
		get_token_exist : function (){
			var params = new URLSearchParams();
			axios.post("/api/google/get_cal_status.php",params)
			.then(response => {
				this.cal_status = response.data['status'];
				console.log(this.cal_status);
			});
		},
		del_cal_token : function (){
			var params = new URLSearchParams();

			if(confirm("Googleカレンダーとの連携を解除いたします。よろしいですか？") == false)
			{
				return;
			}

			axios.post("/api/google/del_cal_token.php",params)
			.then(() => {
				/* */
				this.cal_status = false;
			});

		},
	},
	created: function() {
        this.get_token_exist();
    },
}
</script>
